import { Buffer } from "buffer";
import React from "react";

// Navigate
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Mui
import constant from "@/config/constant";
import formatBytes from "@/lib/formatBytes";
import getExtension from "@/lib/getExtension";
import AddIcon from "@mui/icons-material/Add";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DownloadIcon from "@mui/icons-material/Download";
import ForwardIcon from "@mui/icons-material/Forward";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Mui Styles
import { StyledButton, StyledPaper } from "@/styles/mui/globalStyles";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";

// Components
import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import Layout from "@/components/layout";
import Title from "@/components/title";
//lodash
import _ from "lodash";

//fetch
import {
  createExpenses,
  downloadAttachment,
  getExpensesById,
  updateExpenses,
} from "@/fetch/fetchExpenses";
import { getProducts } from "@/fetch/fetchStatistics";

import { setGlobalMessage } from "@/features/systemSlice";
import { useCurrentAction } from "@/hooks/user";
import moment from "moment";
import { useDispatch } from "react-redux";

const ExpensesDetailPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const mode = location.pathname.split("/")[2];
  const disabled = !actions?.update || mode === "view";
  // Navigate and Location and Params
  const navigate = useNavigate();
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  // States
  const [formData, setFormData] = React.useState({
    id: null,
    name: null,
    category: null,
    cost: 0,
    product_ids: [],
    costs: [
      {
        cost: 0,
        start_date: null,
        end_date: null,
        remark: null,
      },
    ],
    remark: null,
    start_date: null,
    end_date: null,
    attachments: [],
  });

  const [productOptions, setProductOptions] = React.useState([]);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [error, setError] = React.useState({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            marginBottom: 10,
          },
        },
      },
    },
  });
  const handleOnClick = async () => {
    try {
      setIsSubmitting(true);
      setSnackSeverity("success");
      const _error = {};
      if (!formData.name) {
        _error["name"] = true;
      }
      if (formData.product_ids.length <= 0) {
        _error["product_ids"] = true;
      }
      if (formData.attachments.length > 0) {
        setSnackMessage("上載附件中....");
        setSnackOpen(true);
      }
      const allDate = _.sortBy(
        _.flatMap(
          _.map(formData.costs, (cost, index) => {
            if (!cost.start_date) {
              _error[`${index}_start_date`] = true;
            }
            if (!cost.end_date) {
              _error[`${index}_end_date`] = true;
            }
            if (!cost.cost) {
              _error[`${index}_cost`] = true;
            }
            return [cost.start_date, cost.end_date];
          }),
        ),
      );
      const submitData = { ...formData };
      submitData.start_date = allDate[0];
      submitData.end_date = allDate[allDate.length - 1];
      if (!_.isEmpty(_error)) {
        setError(_error);
        throw new Error("fieldCannotBeNull");
      }
      if (id) {
        await updateExpenses(id, submitData);
        dispatch(
          setGlobalMessage({
            message: {
              severity: "success",
              code: 200,
              message: "更新成功",
              isError: false,
            },
          }),
        );
        navigate(`/expenses/edit/${id}`);
      } else {
        const { data } = await createExpenses(submitData);
        dispatch(
          setGlobalMessage({
            message: {
              severity: "success",
              code: 200,
              message: "新增成功",
              isError: false,
            },
          }),
        );
        navigate(`/expenses/edit/${data.id}`);
      }
    } catch (err) {
      switch (err.message) {
        case "fieldCannotBeNull":
          setSnackOpen(false);
          break;

        default:
          setGlobalMessage({
            message: {
              severity: "error",
              code: 500,
              message: "更新失敗",
              isError: true,
            },
          });
          break;
      }
      console.log(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleDelete = async (attachment, index) => {
    const costs = [...formData.costs];

    const attachments = costs[index].attachments;
    const attachmentsIndex = _.findIndex(
      attachments,
      (a) => a.name === attachment.name,
    );
    if (attachments[attachmentsIndex].action === "new") {
      _.remove(attachments, (a) => a.name === attachment.name);
    } else {
      attachments[attachmentsIndex].action = "delete";
    }
    setFormData((prev) => {
      return {
        ...prev,
        costs: costs,
      };
    });
  };
  const handleDownload = async (attachment) => {
    try {
      const { data: url } = await downloadAttachment(attachment);
      window.open(url, "_blank");
    } catch (error) {}
  };
  const checkIsExist = (filename, index) => {
    let name = filename;
    const existIndex = _.findIndex(
      formData.costs[index].attachments,
      (imageData) => imageData.name === filename,
    );
    if (existIndex >= 0) {
      const ext = getExtension(filename);
      const fileName = _.dropRight(filename.split(".")).join(".");
      name = `${fileName}(1).${ext}`;
      return checkIsExist(name, index);
    } else {
      return name;
    }
  };
  const handleUpload = async (event, index) => {
    const costs = [...formData.costs];
    const files = event.target.files;
    if (!costs[index].attachments) {
      costs[index].attachments = [];
    }
    for (let i = 0; i < files.length; i++) {
      let name = checkIsExist(files[i].name, index);
      const base64Data = await convertBase64(files[i]);
      const buffer = Buffer.from(base64Data, "base64");
      costs[index].attachments.push({
        action: "new",
        buffer: buffer,
        name: name,
        size: files[i].size,
        type: files[i].type,
      });
    }
    setFormData((prev) => {
      return {
        ...prev,
        costs,
      };
    });
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        const base64Data = fileReader.result.split("base64,")[1];
        resolve(base64Data);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const fetch = async () => {
    const { data } = await getProducts(false);
    setProductOptions(data);
    if (id) {
      const { data: expenses } = await getExpensesById(id);
      setFormData({
        id: expenses.id,
        name: expenses.name,
        category: expenses.category,
        cost: expenses.cost,
        costs: expenses.costs.length > 0 ? expenses.costs : formData.costs,
        product_ids: expenses.product_ids,
        remark: expenses.remark,
        start_date: moment(expenses.start_date).format("YYYY-MM-DD"),
        end_date: moment(expenses.end_date).format("YYYY-MM-DD"),
        attachments: expenses.attachments,
      });
    }

    setSlideTranOn(true);
  };

  React.useEffect(() => {
    fetch();
  }, []);

  return (
    <Layout
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
      snackSeverity={snackSeverity}
    >
      <Title
        title={`開支管理 / ${id ? "修改開支" : "新增開支"}`}
        history={() => navigate(-1)}
      />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <ThemeProvider theme={theme}>
            <Box validate="true" sx={{ width: 1, flex: 1 }}>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 4,
                    lg: 4,
                  }}
                >
                  <TextField
                    disabled={disabled}
                    id="name"
                    name="name"
                    label="公司名稱"
                    value={formData.name}
                    error={error["name"]}
                    helperText={error[`name`] ? "不能為空" : ""}
                    onChange={(event) =>
                      setFormData({
                        ...formData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 4,
                    lg: 4,
                  }}
                >
                  <TextField
                    disabled={disabled || !formData.parent_id}
                    select
                    id="category"
                    name="category"
                    label="類別"
                    error={!formData.category}
                    value={formData.category}
                    helperText={!formData.category ? "請選擇類別" : ""}
                    onChange={(event) =>
                      setFormData({
                        ...formData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  >
                    <MenuItem disabled>請選擇</MenuItem>
                    {constant.expensesCategory.map((category, index) => {
                      return (
                        <MenuItem key={index} value={category}>
                          {category}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 4,
                    lg: 4,
                  }}
                >
                  <ProductAutoComplete
                    fullWidth={true}
                    multiple={true}
                    disabled={disabled || !formData.parent_id}
                    productOptions={productOptions}
                    handleOnChange={(value) => {
                      setFormData({
                        ...formData,
                        product_ids: value,
                      });
                    }}
                    selectedValue={formData.product_ids}
                    error={error.product_ids}
                  ></ProductAutoComplete>
                </Grid>
                {_.map(formData.costs, (cost, index) => {
                  return (
                    <React.Fragment>
                      <Grid
                        size={{
                          xs: 12,
                          md: 2,
                          lg: 2,
                        }}
                      >
                        <Grid container spacing={1}>
                          <Grid
                            size={{
                              xs: 12,
                              md: 3,
                              lg: 3,
                            }}
                          >
                            <IconButton
                              disabled={disabled}
                              color={"error"}
                              sx={{ mb: 1, mt: 1 }}
                              onClick={() => {
                                const _formData = { ...formData };
                                _formData.costs.splice(index, 1);
                                setFormData(_formData);
                              }}
                            >
                              <DeleteForeverIcon></DeleteForeverIcon>
                            </IconButton>
                          </Grid>
                          <Grid
                            size={{
                              xs: 12,
                              md: 9,
                              lg: 9,
                            }}
                          >
                            <DatePicker
                              disabled={disabled}
                              label="開始日期"
                              value={cost.start_date}
                              name="start_date"
                              onChange={(newValue) => {
                                const _formData = { ...formData };
                                _formData["costs"][index]["start_date"] =
                                  moment(newValue).format("YYYY-MM-DD");
                                setFormData(_formData);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={error[`${index}_start_date`]}
                                  helperText={
                                    error[`${index}_start_date`]
                                      ? "不能為空"
                                      : ""
                                  }
                                  sx={{ width: "100%" }}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        size={{
                          xs: 12,
                          md: 2,
                          lg: 2,
                        }}
                      >
                        <Grid container spacing={1}>
                          <Grid
                            size={{
                              xs: 12,
                              md: 3,
                              lg: 3,
                            }}
                          >
                            <IconButton color={"info"} sx={{ mb: 1, mt: 1 }}>
                              <ForwardIcon></ForwardIcon>
                            </IconButton>
                          </Grid>
                          <Grid
                            size={{
                              xs: 12,
                              md: 9,
                              lg: 9,
                            }}
                          >
                            <DatePicker
                              disabled={disabled}
                              label="結束日期"
                              value={cost.end_date}
                              name="end_date"
                              onChange={(newValue) => {
                                const _formData = { ...formData };
                                _formData["costs"][index]["end_date"] =
                                  moment(newValue).format("YYYY-MM-DD");
                                setFormData(_formData);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={error[`${index}_end_date`]}
                                  helperText={
                                    error[`${index}_end_date`] ? "不能為空" : ""
                                  }
                                  sx={{ width: "100%" }}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        size={{
                          xs: 12,
                          md: 2,
                          lg: 2,
                        }}
                      >
                        <TextField
                          disabled={disabled}
                          id="cost"
                          name="cost"
                          error={error[`${index}_cost`]}
                          helperText={error[`${index}_cost`] ? "不能為空" : ""}
                          label="支出"
                          type="number"
                          value={cost.cost}
                          onChange={(event) => {
                            const _formData = { ...formData };
                            _formData["costs"][index]["cost"] =
                              event.target.value;
                            setFormData(_formData);
                          }}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                      <Grid
                        size={{
                          xs: 12,
                          md: 2,
                          lg: 2,
                        }}
                      >
                        <TextField
                          disabled={disabled}
                          multiline
                          id="remark"
                          name="remark"
                          label="備註"
                          value={cost.remark}
                          onChange={(event) => {
                            const _formData = { ...formData };
                            _formData["costs"][index]["remark"] =
                              event.target.value;
                            setFormData(_formData);
                          }}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                      {!disabled && (
                        <Grid
                          size={{
                            xs: 12,
                            md: 1,
                            lg: 1,
                          }}
                        >
                          <Button
                            disabled={disabled}
                            role={undefined}
                            component="label"
                            tabIndex={-1}
                            sx={{ mb: 1, mt: 1 }}
                            startIcon={<CloudUploadIcon />}
                          >
                            上載附件
                            <VisuallyHiddenInput
                              type="file"
                              onChange={(e) => handleUpload(e, index)}
                              multiple
                            />
                          </Button>
                        </Grid>
                      )}
                      <Grid
                        size={{
                          xs: 12,
                          md: 3,
                          lg: 3,
                        }}
                      >
                        <Box
                          sx={{
                            mb: 2,
                            display: "flex",
                            flexDirection: "column",
                            height: "auto",
                            overflow: "hidden",
                            overflowY: "scroll",
                          }}
                        >
                          <List dense={true}>
                            {_.map(
                              formData.costs[index].attachments,
                              (attachment) => {
                                if (!attachment.isDeleted) {
                                  return (
                                    <ListItem
                                      secondaryAction={
                                        <React.Fragment>
                                          {attachment.action !== "new" && (
                                            <IconButton
                                              edge="end"
                                              color="primary"
                                              aria-label="download"
                                              onClick={() =>
                                                handleDownload(attachment)
                                              }
                                            >
                                              <DownloadIcon />
                                            </IconButton>
                                          )}
                                          <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            color="error"
                                            onClick={() =>
                                              handleDelete(attachment, index)
                                            }
                                          >
                                            <DeleteForeverIcon />
                                          </IconButton>
                                        </React.Fragment>
                                      }
                                    >
                                      <ListItemIcon>
                                        <AttachFileIcon />
                                      </ListItemIcon>
                                      <ListItemText
                                        style={{
                                          textDecorationLine:
                                            attachment.action === "delete"
                                              ? "line-through"
                                              : "none",
                                        }}
                                        primary={`${
                                          attachment.name
                                        } - ${formatBytes(attachment.size)}`}
                                      />
                                    </ListItem>
                                  );
                                }
                              },
                            )}
                          </List>
                        </Box>
                      </Grid>
                    </React.Fragment>
                  );
                })}
                {!disabled && (
                  <Grid
                    size={{
                      xs: 12,
                      md: 12,
                      lg: 12,
                    }}
                  >
                    <Button
                      disabled={disabled}
                      role={undefined}
                      variant="contained"
                      tabIndex={-1}
                      onClick={() => {
                        const _formData = { ...formData };
                        _formData.costs.push({
                          cost: 0,
                          start_date: null,
                          end_date: null,
                          remark: "",
                        });
                        setFormData(_formData);
                      }}
                      startIcon={<AddIcon />}
                    >
                      新增
                      <VisuallyHiddenInput
                        type="file"
                        onChange={handleUpload}
                        multiple
                      />
                    </Button>
                  </Grid>
                )}
                {/* <Grid item xs={12} md={6} lg={6}>
                  <Button
                    component="label"
                    disabled={!actions?.update}
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<CloudUploadIcon />}
                  >
                    上載附件
                    <VisuallyHiddenInput
                      type="file"
                      onChange={handleUpload}
                      multiple
                    />
                  </Button>
                  <Box
                    sx={{
                      mb: 2,
                      display: "flex",
                      flexDirection: "column",
                      height: 130,
                      overflow: "hidden",
                      overflowY: "scroll",
                    }}
                  >
                    <List dense={true}>
                      {_.map(formData.attachments, (attachment) => {
                        if (!attachment.isDeleted) {
                          return (
                            <ListItem
                              secondaryAction={
                                <React.Fragment>
                                  {attachment.action !== "new" && (
                                    <IconButton
                                      edge="end"
                                      color="primary"
                                      aria-label="download"
                                      onClick={() => handleDownload(attachment)}
                                    >
                                      <DownloadIcon />
                                    </IconButton>
                                  )}
                                  <IconButton
                                    edge="end"
                                    aria-label="delete"
                                    color="error"
                                    onClick={() => handleDelete(attachment)}
                                  >
                                    <DeleteForeverIcon />
                                  </IconButton>
                                </React.Fragment>
                              }
                            >
                              <ListItemIcon>
                                <AttachFileIcon />
                              </ListItemIcon>
                              <ListItemText
                                style={{
                                  textDecorationLine:
                                    attachment.action === "delete"
                                      ? "line-through"
                                      : "none",
                                }}
                                primary={`${attachment.name} - ${formatBytes(
                                  attachment.size
                                )}`}
                              />
                            </ListItem>
                          );
                        }
                      })}
                    </List>
                  </Box>
                </Grid> */}
                <Grid
                  size={{
                    xs: 12,
                    md: 4,
                    lg: 4,
                  }}
                ></Grid>
                {!disabled && (
                  <Grid
                    size={{
                      xs: 12,
                      md: 12,
                      lg: 12,
                    }}
                  >
                    <Grid justifyContent={"flex-end"} container spacing={2}>
                      <Grid
                        size={{
                          xs: 12,
                          md: 12,
                          lg: 2,
                        }}
                      >
                        <StyledButton
                          onClick={handleOnClick}
                          variant="contained"
                          size="small"
                          disabled={isSubmitting}
                        >
                          <Typography
                            variant="subtitle1"
                            noWrap
                            component="div"
                          >
                            確認
                          </Typography>
                        </StyledButton>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Box>
          </ThemeProvider>
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default ExpensesDetailPage;
